import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetOperatorDetalization = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_DETALIZATON_OPERATOR
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetOperatorDetalizationAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetOperatorDetalization as SetGetOperatorDetalization
}